import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { dictionary } from '../../../dictionary';

const InvoiceConfirm = ({
  invoiceNumber1,
  setInvoiceNumber1,
  payment1Confirmed,
  setPayment1Confirmed,
  invoiceNumber2,
  setInvoiceNumber2,
  payment2Confirmed,
  setPayment2Confirmed,
}) => {
  return (
    <>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_nr_before}</label>
          <InputText
            style={{ width: '100%' }}
            value={invoiceNumber1 !== null ? invoiceNumber1 : ''}
            placeholder={dictionary.esp_dialog_invoice_nr_placeholder}
            onChange={(e) => {
              setInvoiceNumber1(e.target.value);
            }}
          />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_one_confirmed}</label>
          <Calendar
            style={{ width: '100%' }}
            value={payment1Confirmed}
            onChange={(e) => {
              setPayment1Confirmed(e.value);
            }}
            showIcon
            showButtonBar
            placeholder={dictionary.export_dialog_calendar_placeholder}
            dateFormat="dd-mm-yy"
          />
        </div>
      </div>
      <div className="field-row">
        <div className="col" style={{ marginRight: '0.5rem' }}>
          <label>{dictionary.esp_dialog_invoice_nr_after}</label>
          <InputText
            style={{ width: '100%' }}
            value={invoiceNumber2 !== null ? invoiceNumber2 : ''}
            placeholder={dictionary.esp_dialog_invoice_nr_placeholder}
            onChange={(e) => {
              setInvoiceNumber2(e.target.value);
            }}
          />
        </div>
        <div className="col">
          <label>{dictionary.esp_dialog_invoice_two_confirmed}</label>
          <Calendar
            style={{ width: '100%' }}
            value={payment2Confirmed}
            onChange={(e) => {
              setPayment2Confirmed(e.value);
            }}
            showIcon
            showButtonBar
            placeholder={dictionary.export_dialog_calendar_placeholder}
            dateFormat="dd-mm-yy"
          />
        </div>
      </div>
    </>
  );
};

export default InvoiceConfirm;
